import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CancellationRule } from "../objects/cancellationRule";
import { ManualActivityGlobalCancellationRulesState } from "../objects/manualActivityGlobalCancellationRulesState";


const initialState: ManualActivityGlobalCancellationRulesState = {
    cancellation_rules: [],
    cancellation_rules_loading: false,
    cancellation_rule: null,
};

const addCancellationRuleReducer = (state: ManualActivityGlobalCancellationRulesState, action: PayloadAction<CancellationRule>): ManualActivityGlobalCancellationRulesState => ({
    ...state, cancellation_rules: [{ ...action.payload, periods: action.payload.periods.map((period) => ({ ...period, start_date: period.start_date ? new Date(period.start_date) : null, end_date: period.end_date ? new Date(period.end_date) : null })) }, ...state.cancellation_rules]
});
const updateCancellationRuleReducer = (state: ManualActivityGlobalCancellationRulesState, action: PayloadAction<CancellationRule>): ManualActivityGlobalCancellationRulesState => ({
    ...state, cancellation_rules: state.cancellation_rules.map((cancellation_rule) => cancellation_rule.id === action.payload.id ? { ...action.payload, periods: action.payload.periods.map((period) => ({ ...period, start_date: period.start_date ? new Date(period.start_date) : null, end_date: period.end_date ? new Date(period.end_date) : null })) } : cancellation_rule)
});
const updateCancellationRulesReducer = (state: ManualActivityGlobalCancellationRulesState, action: PayloadAction<CancellationRule[]>): ManualActivityGlobalCancellationRulesState => ({
    ...state, cancellation_rules: action.payload.map((rule) => ({ ...rule, periods: rule.periods.map((period) => ({ ...period, start_date: period.start_date ? new Date(period.start_date) : null, end_date: period.end_date ? new Date(period.end_date) : null })) }))
});
const deleteCancellationRuleReducer = (state: ManualActivityGlobalCancellationRulesState, action: PayloadAction<number>): ManualActivityGlobalCancellationRulesState => ({
    ...state, cancellation_rules: state.cancellation_rules.filter((cancellation_rule) => cancellation_rule.id !== action.payload)
});
const setCancellationRulesLoadingReducer = (state: ManualActivityGlobalCancellationRulesState, action: PayloadAction<boolean>): ManualActivityGlobalCancellationRulesState => ({
    ...state, cancellation_rules_loading: action.payload
});


export const manualActivityGlobalCancellationRule = createSlice({
    name: 'manual_activity_global_cancellation_rule',
    initialState,
    reducers: {
        addCancellationRule: addCancellationRuleReducer,
        updateCancellationRule: updateCancellationRuleReducer,
        updateCancellationRules: updateCancellationRulesReducer,
        deleteCancellationRule: deleteCancellationRuleReducer,
        setCancellationRulesLoading: setCancellationRulesLoadingReducer
    }
});

export const {
    addCancellationRule,
    updateCancellationRule,
    updateCancellationRules,
    deleteCancellationRule,
    setCancellationRulesLoading
} = manualActivityGlobalCancellationRule.actions;